export default __webpack_public_path__ + "static/media/Astronaut_01.f5bccb58.png";